function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22.038 2H6.375a1.755 1.755 0 0 0-1.75 1.75v24.5A1.755 1.755 0 0 0 6.375 30h19.25a1.755 1.755 0 0 0 1.75-1.75V6.856Zm.525 2.844 1.663 1.531h-1.663ZM6.375 28.25V3.75h14.438v4.375h4.813V28.25Z",
  style: {
    fill: "#c2c2c2"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.125 15.097h13.076v1.75H8.125zM8.125 24.439h9.762v1.75H8.125zM8.125 19.763h15.75v1.75H8.125zM8.125 10.23h15.75v1.75H8.125z",
  style: {
    fill: "#829ec2"
  }
}));
export default SvgText;